<template>
  <div class="min-h-screen bg-black text-white py-8 px-4 md:px-8 md:mt-16">
    <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
      <!-- Coluna da esquerda (informacoes do evento) -->
      <div class="md:col-span-2">
        <div class="w-full flex justify-center">
          <img
            :src="
              event?.event?.banner !== null && event?.event?.banner !== '[]'
                ? fileUrl + event?.event?.banner
                : appLogo
            "
            :alt="event?.event?.title"
            class="w-full rounded-lg object-cover max-h-[300px] max-w-[400px]"
          />
        </div>

        <div class="w-full flex justify-center tracking-normal">
          <div class="text-left md:max-w-[400px]">
            <h1 class="text-3xl font-bold mt-6 tracking-wide">
              <!-- Titulo do treinamento -->
              {{ event?.event?.title }}
            </h1>
          </div>
        </div>

        <div class="w-full flex justify-center font-inter tracking-normal">
          <div class="text-left md:max-w-[400px]">
            <div class="flex items-center gap-2 mt-4 text-gray-300">
              <PhCalendar class="w-5 h-5" />
              <span>{{ formatDate(event?.event?.starts_at) }}</span>
            </div>

            <div class="flex items-center gap-2 mt-2 text-gray-300">
              <PhClock class="w-5 h-5" />
              <span>{{ formatHour(event?.event?.starts_at) }}</span>
            </div>

            <div class="flex items-center gap-2 mt-2 text-gray-300">
              <PhMapPinArea class="w-5 h-5" />
              <span>{{ event?.event?.location ?? "não informado" }}</span>
            </div>

            <div class="mt-8 font-inter">
              <h2 class="text-xl font-semibold mb-2">Detalhes do treinamento</h2>
              <p class="text-gray-400">
                <!-- Lorem ipsum dolor, sit amet consectetur adipisicing elit. Corporis maxime iusto odit quidem. Cupiditate dolore recusandae quae atque repellendus modi pariatur minus quidem ratione vitae, optio iste, tempore porro alias. -->
                {{ event?.event?.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna da direita (checkout/resumo) -->
      <div class="relative" :key="event">
        <div class="bg-zinc-900 rounded-lg p-6 sticky top-8">
          <div :key="acquired">
            <button
              v-if="canAccess"
              class="w-full bg-red-600 hover:bg-red-700 transition rounded-lg text-white py-3 font-bold text-center uppercase text-2xl md:text-xl"
              @click="goToEvent()"
            >
              Acessar treinamento
            </button>

            <button
              v-else
              class="w-full bg-red-600 hover:bg-red-700 transition rounded-lg text-white py-3 font-bold text-center uppercase text-2xl md:text-xl"
              @click="goToWhatsapp(event?.event)"
            >
              Solicitar acesso ao treinamento
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { showToast as toast } from "@/helpers/UseToasts";
import router from "@/router";
import SharedService from "@/shared/services/shared";
import { dataShared } from "@/shared/store";
import { formatDate, formatHour } from "@/utils/formaters";
import { PhCalendar, PhClock, PhMapPinArea } from "@phosphor-icons/vue";
import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import defaultLogo from "@/assets/logo/icon.png";

const route = useRoute();
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + "storage/";
const eventId = route.params.id;
const event = ref({});
const customer = computed(() => dataShared.getters.getDataByUserLogged)

// const sponsorshipPage = ref(false);
// const couponId = computed(() => route.query.couponId);
// const isPaid = ref(true);
// const banner = require("./../../../assets/logo/logo-rs-bg.png");
// const fighter = route.query.fighter;
// const affiliate = route.query.affiliate;

const user = computed(() => dataShared.getters.getDataByUserLogged);
const acquired = computed(() => {
  return user.value?.purchases.some((p) => p?.event_id == eventId);
});
const groupId = computed(() => {
  return user.value?.purchases.find((p) => p?.event_id == eventId);
});
// const freeEvent = computed(() => event.value?.event?.price == null); // price
const freeEvent = ref(false);
const canAccess = computed(() => {
  return acquired.value || freeEvent.value;
});
const appLogo = computed(() => {
  return dataShared.getters.getLogo || defaultLogo;
});

// dados do treinamento
async function getItem() {
  dataShared.dispatch("activeLoading");
  await SharedService.getEventById(eventId)
    .then((res) => {
      console.log(res.data);

      event.value.event = res.data;
      dataShared.dispatch("desactiveLoading");
    })
    .catch((err) => {
      dataShared.dispatch("desactiveLoading");
      if (err?.response?.data?.error && err.response.data.status === 400) {
        router.push({ name: "home" });
        return toast("Aviso", err.response.data.message, "error");
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        router.push({ name: "home" });
        return toast("Aviso", err.response.data.message, "error");
      }

      if (err?.response?.data?.error && err.response.data.status === 429) {
        router.push({ name: "auth" });
        return toast("Aviso", err.response.data.message, "error");
      }
    });
}

function isIOS () {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

// solicitar acesso ao treinamento via whatsapp
async function goToWhatsapp(data) {
  let phone = "15 99704-4678";
  const formattedPhone = phone
    .replace(/\D/g, "")
    .replace(/^0/, "")
    .replace(/^/, "55");

  const training = data?.title

  const message = `Olá *${
    'X Solution,'
  }* tudo bem?%0AAqui é o *${customer.value?.name.split(' ')[0]}*%0A%0AGostaria de solicitar a vocês acesso ao seguinte treinamento:%0A%0A*${training}*
  %0A%0AMuito obrigado e até breve!`;

  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${message}`;

  if (isIOS()) {
    return (location.href = whatsappUrl);
  }

  toast("Sucesso", "Sua solicitação foi enviada", "success");

  return window.open(whatsappUrl, "_blank");
}

// caso já tenha acesos ao evento
function goToEvent() {
  router.push({
    path: `/module/${eventId}`,
    query: groupId.value?.group_id ? { group: groupId.value?.group_id } : {}
  });
}

onBeforeMount(async () => {
  await dataShared.dispatch("fetchLoggedUser");
});

onMounted(() => {
  window.scrollTo(-10, -10);
  dataShared.dispatch("activeLoading");

  Promise.all([getItem()]);

  dataShared.dispatch("desactiveLoading");
});
</script>

<style scoped>
@media (max-width: 768px) {
  .sticky {
    position: relative;
    top: unset;
  }
}
</style>
